/**
 * Servicio centralizado para llamadas a la API
 */

import { API_BASE_URL } from '../config/constants';

/**
 * Realiza una petición fetch con manejo de errores
 * @param {string} endpoint - Endpoint de la API
 * @param {RequestInit} options - Opciones de fetch
 * @returns {Promise<any>}
 */
export const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, { ...defaultOptions, ...options });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Realiza una búsqueda
 * @param {string} query - Término de búsqueda
 * @returns {Promise<any>}
 */
export const search = async (query) => {
  return apiRequest(`/api/search.php?search=${encodeURIComponent(query)}`);
};

/**
 * Obtiene datos de un recurso
 * @param {string} resource - Nombre del recurso
 * @param {string|number} id - ID del recurso
 * @returns {Promise<any>}
 */
export const getResource = async (resource, id) => {
  return apiRequest(`/api/${resource}.php?id=${id}`);
};

/**
 * Crea un nuevo recurso
 * @param {string} resource - Nombre del recurso
 * @param {object} data - Datos del recurso
 * @returns {Promise<any>}
 */
export const createResource = async (resource, data) => {
  return apiRequest(`/api/${resource}.php`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

/**
 * Actualiza un recurso existente
 * @param {string} resource - Nombre del recurso
 * @param {string|number} id - ID del recurso
 * @param {object} data - Datos actualizados
 * @returns {Promise<any>}
 */
export const updateResource = async (resource, id, data) => {
  return apiRequest(`/api/${resource}.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

/**
 * Elimina un recurso
 * @param {string} resource - Nombre del recurso
 * @param {string|number} id - ID del recurso
 * @returns {Promise<any>}
 */
export const deleteResource = async (resource, id) => {
  return apiRequest(`/api/${resource}.php?id=${id}`, {
    method: 'DELETE',
  });
};

